import { TriggerType } from '@business/entities/webhook';
import { R } from '@core/utils/r';

export function getTitle(type: TriggerType): string {
  switch (type) {
    case TriggerType.contact || TriggerType.organization || TriggerType.deal:
      return R.upperFirst(type);
    case TriggerType.contactOrg:
      return 'Contact/Organization';
    case TriggerType.automations:
      return 'Automations';
  }

  return R.upperFirst(type);
}
